import React, { useState } from "react";

import {
  MapPin,
  Phone,
  Mail,
  Clock,
  Send,
  CheckCircle,
  MessageSquare,
  Users,
  ArrowRight,
} from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Alert, AlertDescription } from "../components/ui/alert";

export default function Contact() {
   const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitted(false);

    try {
      const res = await fetch("https://ghandiva.biz.id/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Server error");

      const data = await res.json();

      if (data.success) {
        setSubmitted(true);
        setFormData({
          name: "",
          email: "",
          company: "",
          phone: "",
          service: "",
          message: "",
        });
      }
    } catch (err) {
      console.error("Submit error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-b from-gray-50/50 to-white">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-gray-700 to-gray-900 bg-clip-text text-transparent">
                Hubungi Ghandiva
              </span>
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Siap membantu mewujudkan transformasi digital perusahaan Anda.
              Mari diskusikan kebutuhan teknologi bisnis Anda bersama tim ahli
              Ghandiva.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Form */}
           {/* FORM */}
          <div>
            <h2 className="text-3xl font-bold mb-4">Konsultasi Gratis</h2>
            <p className="text-gray-600 mb-8">
              Kami akan merespons dalam waktu maksimal 24 jam.
            </p>

            {submitted && (
              <Alert className="mb-8 border-green-200 bg-green-50">
                <CheckCircle className="h-4 w-4 text-green-600" />
                <AlertDescription className="text-green-800">
                  Pesan berhasil dikirim. Tim kami akan segera menghubungi Anda.
                </AlertDescription>
              </Alert>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <Label>Nama *</Label>
                  <Input
                    value={formData.name}
                    onChange={(e) =>
                      handleInputChange("name", e.target.value)
                    }
                    required
                  />
                </div>
                <div>
                  <Label>Email *</Label>
                  <Input
                    type="email"
                    value={formData.email}
                    onChange={(e) =>
                      handleInputChange("email", e.target.value)
                    }
                    required
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <Input
                  placeholder="Perusahaan"
                  value={formData.company}
                  onChange={(e) =>
                    handleInputChange("company", e.target.value)
                  }
                />
                <Input
                  placeholder="No. Telepon"
                  value={formData.phone}
                  onChange={(e) =>
                    handleInputChange("phone", e.target.value)
                  }
                />
              </div>

              <select
                value={formData.service}
                onChange={(e) =>
                  handleInputChange("service", e.target.value)
                }
                className="w-full border rounded-lg px-3 py-2"
              >
                <option value="">Pilih layanan</option>
                <option>Web Development</option>
                <option>Mobile App</option>
                <option>Cloud</option>
                <option>Cybersecurity</option>
                <option>IT Consulting</option>
              </select>

              <Textarea
                required
                value={formData.message}
                onChange={(e) =>
                  handleInputChange("message", e.target.value)
                }
                placeholder="Ceritakan kebutuhan Anda..."
              />

              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gray-700 hover:bg-gray-800 text-white"
              >
                {isSubmitting ? "Mengirim..." : "Kirim Pesan"}
                {!isSubmitting && <Send className="ml-2 w-4 h-4" />}
              </Button>
            </form>
          </div>

            {/* Contact Information */}
            <div>
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Informasi Kontak
                </h2>

                <div className="space-y-8">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-6 h-6 text-gray-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">
                        Alamat Kantor
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        Jl. Wonoayu No. 10, Sawunggaling, Kec Wonokromo,
                        <br />
                        Surabaya, Jawa Timur 60242, Indonesia
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Phone className="w-6 h-6 text-gray-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">
                        Telepon
                      </h3>
                      <p className="text-gray-600">+62 89 5186 31300</p>
                      <p className="text-gray-600">
                        +62 89 5186 31300 (WhatsApp)
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Mail className="w-6 h-6 text-gray-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">
                        Email
                      </h3>
                      <p className="text-gray-600">info@ghandiva.biz.id</p>
                      <p className="text-gray-600">support@ghandiva.biz.id</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Clock className="w-6 h-6 text-gray-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">
                        Jam Operasional
                      </h3>
                      <p className="text-gray-600">
                        Senin - Jumat: 09:00 - 18:00
                      </p>
                      <p className="text-gray-600">Sabtu: 09:00 - 15:00</p>
                      <p className="text-sm text-gray-500 mt-1">
                        Support 24/7 untuk klien existing
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="bg-gray-50 rounded-3xl p-8">
                <h3 className="text-xl font-semibold text-gray-900 mb-6">
                  Cara Lain Menghubungi
                </h3>
                <div className="space-y-4">
                  <a
                    href="https://wa.me/6289518631300"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-4 bg-white rounded-2xl hover:shadow-md transition-all duration-300 group"
                  >
                    <MessageSquare className="w-6 h-6 text-green-600" />
                    <div className="flex-1">
                      <div className="font-medium text-gray-900">WhatsApp</div>
                      <div className="text-sm text-gray-600">
                        Chat langsung dengan tim kami
                      </div>
                    </div>
                    <ArrowRight className="w-5 h-5 text-gray-400 group-hover:translate-x-1 transition-transform" />
                  </a>

                  <a
                    href="tel:+6289518631300"
                    className="flex items-center gap-3 p-4 bg-white rounded-2xl hover:shadow-md transition-all duration-300 group"
                  >
                    <Phone className="w-6 h-6 text-gray-600" />
                    <div className="flex-1">
                      <div className="font-medium text-gray-900">Telepon</div>
                      <div className="text-sm text-gray-600">
                        Hubungi langsung untuk urgent
                      </div>
                    </div>
                    <ArrowRight className="w-5 h-5 text-gray-400 group-hover:translate-x-1 transition-transform" />
                  </a>

                  <div className="flex items-center gap-3 p-4 bg-white rounded-2xl">
                    <Users className="w-6 h-6 text-gray-600" />
                    <div className="flex-1">
                      <div className="font-medium text-gray-900">Meeting</div>
                      <div className="text-sm text-gray-600">
                        Jadwalkan konsultasi offline
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Lokasi Kantor
            </h2>
            <p className="text-gray-600">
              Kunjungi kantor kami untuk konsultasi langsung
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-lg">
            <div className="aspect-video bg-gray-100 rounded-2xl overflow-hidden">
              <iframe
              title="Lokasi Kantor Ghandiva Surabaya"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3957.617875402434!2d112.7274651749968!3d-7.299001292710137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd7fa1b7c2bb4e1%3A0x44e8c4cbbaf3db23!2sJl.%20Wonoayu%20No.10%2C%20Sawunggaling%2C%20Wonokromo%2C%20Surabaya%2C%20Jawa%20Timur%2060242!5e0!3m2!1sid!2sid!4v1724256000000!5m2!1sid!2sid"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
